import * as Yup from 'yup';
import {FIELD_ERRORS} from '../../../constants';

export interface IAdditionalInfoForm {
    title: string;
}

export const initial: IAdditionalInfoForm = {title: ''};

export const validationSchema = Yup.object({
    title: Yup.string().required(FIELD_ERRORS.REQUIRED),
});
